import * as React from "react";
import { Icon } from "../Icon/icon";

export interface IPreviousProps {
  isEnabled: boolean;
  onClickCallback?(e: React.MouseEvent<HTMLAnchorElement>): void;
  label: string;
}

/**
 * The Previous link of a [[ContentPagination]]
 */
export class Previous extends React.PureComponent<IPreviousProps> {
  private _backArrow = (<Icon iconType="fontawesome/chevron-left" />);
  static defaultProps = {
    onClickCallback: () => {},
  };

  constructor(props: IPreviousProps) {
    super(props);
  }

  public render() {
    const { isEnabled, label } = this.props;
    let anchorClassName = "pagination__link";
    if (!isEnabled) anchorClassName += " pagination__link--disabled";
    let JSX: JSX.Element = null;
    if (isEnabled) {
      JSX = (
        <a
          onClick={this.props.onClickCallback}
          href="#"
          className={anchorClassName}
        >
          {this._backArrow}
          <span className="pagination__verbose">{label}</span>
        </a>
      );
    } else {
      JSX = (
        <span aria-disabled="true" className={anchorClassName}>
          {this._backArrow}
          <span className="pagination__verbose">{label}</span>
        </span>
      );
    }

    return JSX;
  }
}
